import { render, staticRenderFns } from "./BundlePlan.vue?vue&type=template&id=074aecd6&scoped=true"
import script from "./BundlePlan.vue?vue&type=script&lang=js"
export * from "./BundlePlan.vue?vue&type=script&lang=js"
import style0 from "./BundlePlan.vue?vue&type=style&index=0&id=074aecd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074aecd6",
  null
  
)

export default component.exports